import { FormFields } from ".";

export const INCOME_DETAILS_FIELDS: FormFields = {
  fields: [
    {
      name: "monthlyIncome",
      label: "Monthly Income (₹)",
      type: "tel",
      validationRules: {
        required: true,
        errorMessage: "Monthly income is required",
        pattern: {
          value: /^[0-9]+(\.[0-9]{1,2})?$/,
          message: "Please enter a valid amount (up to 2 decimal places)",
        },
      },
    },
    {
      name: "otherMonthlyIncome",
      label: "Other Monthly Income (₹)",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^[0-9]+(\.[0-9]{1,2})?$/,
          message: "Please enter a valid amount (up to 2 decimal places)",
        },
      },
    },
    {
      name: "assets",
      label: "Assets",
      type: "multiselect",
      options: ["LAND", "CAR", "TWO WHEELER", "HOUSE", "GOLD", "SHARES", "PLOT", "FARM"],
      validationRules: {
        required: false,
      },
    },
  ],
};
